import React from 'react';
import { Container } from '../ui/Container';
import { Phone, Mail, MapPin, Facebook, Instagram, Linkedin } from 'lucide-react';
export function Footer() {
  return <footer className="bg-gray-900 text-gray-300 pt-16 pb-8" data-id="element-11">
      <Container data-id="element-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-13">
          {/* Column 1: Brand */}
          <div className="space-y-6" data-id="element-14">
            <img src="https://cdn.magicpatterns.com/uploads/7TKvSYNRQpruyHTqp7chDT/Digital_Printing_LOGO_CMYK_white_stacked-01.png" alt="Digital Printing - Make a Lasting Impression" className="h-20 w-auto" data-id="element-15" />
            <p className="text-sm leading-relaxed text-gray-400" data-id="element-16">
              Professional printing and signage solutions delivered
              Australia-wide. Quality you can trust, deadlines you can depend
              on.
            </p>
            <div className="space-y-3" data-id="element-17">
              <a href="tel:0894033306" className="flex items-center text-sm hover:text-cyan-400 transition-colors" data-id="element-18">
                <Phone className="h-4 w-4 mr-3" data-id="element-19" />
                08 9403 3306
              </a>
              <a href="mailto:sales@digitalprintingoz.com.au" className="flex items-center text-sm hover:text-cyan-400 transition-colors" data-id="element-20">
                <Mail className="h-4 w-4 mr-3" data-id="element-21" />
                sales@digitalprintingoz.com.au
              </a>
              <div className="flex items-start text-sm" data-id="element-22">
                <MapPin className="h-4 w-4 mr-3 mt-1 flex-shrink-0" data-id="element-23" />
                <span data-id="element-24">
                  Digital Printing Pty Ltd
                  <br data-id="element-25" />
                  Australia
                </span>
              </div>
            </div>
          </div>

          {/* Column 2: Services */}
          <div data-id="element-26">
            <h3 className="text-white font-semibold mb-6" data-id="element-27">Services</h3>
            <ul className="space-y-3 text-sm" data-id="element-28">
              <li data-id="element-29">
                <a href="#business-cards" className="hover:text-cyan-400 transition-colors" data-id="element-30">
                  Business Cards
                </a>
              </li>
              <li data-id="element-31">
                <a href="#signage" className="hover:text-cyan-400 transition-colors" data-id="element-32">
                  Signage & Installation
                </a>
              </li>
              <li data-id="element-33">
                <a href="#services" className="hover:text-cyan-400 transition-colors" data-id="element-34">
                  Flyers & Brochures
                </a>
              </li>
              <li data-id="element-35">
                <a href="#services" className="hover:text-cyan-400 transition-colors" data-id="element-36">
                  Posters & Banners
                </a>
              </li>
              <li data-id="element-37">
                <a href="#services" className="hover:text-cyan-400 transition-colors" data-id="element-38">
                  Stickers & Labels
                </a>
              </li>
              <li data-id="element-39">
                <a href="#quote" className="hover:text-cyan-400 transition-colors" data-id="element-40">
                  Graphic Design
                </a>
              </li>
            </ul>
          </div>

          {/* Column 3: Company */}
          <div data-id="element-41">
            <h3 className="text-white font-semibold mb-6" data-id="element-42">Company</h3>
            <ul className="space-y-3 text-sm" data-id="element-43">
              <li data-id="element-44">
                <a href="#about" className="hover:text-cyan-400 transition-colors" data-id="element-45">
                  About Us
                </a>
              </li>
              <li data-id="element-46">
                <a href="#contact" className="hover:text-cyan-400 transition-colors" data-id="element-47">
                  Contact
                </a>
              </li>
              <li data-id="element-48">
                <a href="#" className="hover:text-cyan-400 transition-colors" data-id="element-49">
                  Blog & Insights
                </a>
              </li>
              <li data-id="element-50">
                <a href="#" className="hover:text-cyan-400 transition-colors" data-id="element-51">
                  Careers
                </a>
              </li>
              <li data-id="element-52">
                <a href="#" className="hover:text-cyan-400 transition-colors" data-id="element-53">
                  Sitemap
                </a>
              </li>
            </ul>
          </div>

          {/* Column 4: Help */}
          <div data-id="element-54">
            <h3 className="text-white font-semibold mb-6" data-id="element-55">Support</h3>
            <ul className="space-y-3 text-sm" data-id="element-56">
              <li data-id="element-57">
                <a href="#" className="hover:text-cyan-400 transition-colors" data-id="element-58">
                  Artwork Guidelines
                </a>
              </li>
              <li data-id="element-59">
                <a href="#" className="hover:text-cyan-400 transition-colors" data-id="element-60">
                  Proofing Process
                </a>
              </li>
              <li data-id="element-61">
                <a href="#" className="hover:text-cyan-400 transition-colors" data-id="element-62">
                  Delivery Information
                </a>
              </li>
              <li data-id="element-63">
                <a href="#" className="hover:text-cyan-400 transition-colors" data-id="element-64">
                  Returns Policy
                </a>
              </li>
              <li data-id="element-65">
                <a href="#" className="hover:text-cyan-400 transition-colors" data-id="element-66">
                  FAQ
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-67">
          <p className="text-sm text-gray-500" data-id="element-68">
            © {new Date().getFullYear()} Digital Printing Pty Ltd. All rights
            reserved.
          </p>
          <div className="flex gap-6 text-sm text-gray-500" data-id="element-69">
            <a href="#" className="hover:text-white transition-colors" data-id="element-70">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-71">
              Terms of Service
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-72">
              Accessibility
            </a>
          </div>
          <div className="flex gap-4" data-id="element-73">
            <a href="#" className="text-gray-500 hover:text-white transition-colors" aria-label="Facebook" data-id="element-74">
              <Facebook className="h-5 w-5" data-id="element-75" />
            </a>
            <a href="#" className="text-gray-500 hover:text-white transition-colors" aria-label="Instagram" data-id="element-76">
              <Instagram className="h-5 w-5" data-id="element-77" />
            </a>
            <a href="#" className="text-gray-500 hover:text-white transition-colors" aria-label="LinkedIn" data-id="element-78">
              <Linkedin className="h-5 w-5" data-id="element-79" />
            </a>
          </div>
        </div>
      </Container>
    </footer>;
}